/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Use_Case_ResearchInputs */



/**
* | output |
* | --- |
* | "Research" |
*
* @param {Model_Showcase_Use_Case_ResearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_use_case_research = /** @type {((inputs?: Model_Showcase_Use_Case_ResearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Use_Case_ResearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Recherche")
	return /** @type {LocalizedString} */ ("Research")
});